/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const termsEditorInspector = {
	errors: {
		propertyCannotBeEdited: "inspector:errors.propertyCannotBeEdited",
		internalInvalidModelNode: "inspector:errors.internalInvalidModelNode",
		componentHasInvalidConfiguration: "inspector:errors.componentHasInvalidConfiguration",
		dataSourceHasInvalidConfiguration: "inspector:errors.dataSourceHasInvalidConfiguration",
		flowNodeHasInvalidConfiguration: "inspector:errors.flowNodeHasInvalidConfiguration"
	},
	component: {
		name: {
			label: "inspector:component.name#label"
		},
		id: {
			label: "inspector:component.id#label"
		},
		delete: "inspector:component.delete#title",
		duplicate: "inspector:component.duplicate#title",
		openDocumentation: "inspector:component.openDocumenation#title"
	},
	dataSource: {
		id: {
			label: "inspector:dataSource.id#label"
		},
		delete: "inspector:dataSource.delete#title",
		duplicate: "inspector:dataSource.duplicate#title",
		openDocumentation: "inspector:dataSource.openDocumenation#title"
	},
	common: {
		setAsDynamicValue: "inspector:common.setAsDynamicValue"
	}
};
